
export enum Strings {
    //banner
    manual = "manual",
    prebooking = "prebooking",
    music_box = "music_box",
    fetch_limit = "fetch_limit",
    Deactivated = "Deactivated",
    NA = "NA",
    default = "default",
    subscription_plan = "subscription_plan",
    click_setting_icon = "click_setting_icon",
    defaulttoneconfirm = "defaulttoneconfirm",
    shuffle_activate = "shuffle_activate",
    shuffle_deactivate = "shuffle_deactivate",
    You_cannot_access_advanced_settings_for_Non_Active_tunes = "You_cannot_access_advanced_settings_for_Non_Active_tunes",
    //blacklist
    active_status = "active_status",
    start_discovering = "start_discovering",
    no_blacklist_at_the_moment = "no_blacklist_at_the_moment",
    black_list = "black_list",
    create_and_manage_list_of_number_to_be_blacklisted = "create_and_manage_list_of_number_to_be_blacklisted",
    are_you_sure_you_want_to_delete_number_from_blacklist = "are_you_sure_you_want_to_delete_number_from_blacklist",
    please_add_atleast_one_member_to_blacklist = "please_add_atleast_one_member_to_blacklist",
    member_name_is_mandatory = "member_name_is_mandatory",
    member_name_max_length = "member_name_max_length",
    member_number_max_length = "member_number_max_length",
    mobile_number_is_mandatory = "mobile_number_is_mandatory",
    mobile_number_must_be_unique = "mobile_number_must_be_unique",
    already_added_as_member = "already_added_as_member",
    please_add_atleast_one_member_to_your_group = "please_add_atleast_one_member_to_your_group",
    your_not_active_rbt_subscriber = "your_not_active_rbt_subscriber",
    no_tunes_available = "no_tunes_available",
    please_select_repeat = "please_select_repeat",
    common_strings = "common_strings",
    inactive_subscriber = "inactive_subscriber",
    wishlist_delete_order_is_successfully_completed = "wishlist_delete_order_is_successfully_completed",
    wishlist_add_order_is_successfully_completed = "wishlist_add_order_is_successfully_completed",
    wishlist_confirm_delete_msg = "wishlist_confirm_delete_msg",
    you_are_not_an_active_subscriber = "you_are_not_an_active_subscriber",
    search = "search",
    get_tunes = "get_tunes",
    no_wishes = "no_wishes",
    save = "save",
    no_history = "no_history",
    save_anyway = "save_anyway",
    review = "review",
    copy = "copy",
    edit = "edit",
    ok = "ok",
    delete = "delete",
    cancel = "cancel",
    close = "close",
    reset = "reset",
    help = "help",
    no_data = "no_data",
    more_options = "more_options",
    no_nodes_available = "no_nodes_available",
    no_data_list_available = "no_data_list_available",
    add = "add",
    gift_default_value = "gift_default_value",
    success = "success",
    faliure = "faliure",
    alert = "alert",
    confirm = "confirm",
    change_password = "change_password",
    regular_expression = "regular_expression",
    logout = "logout",
    singer = "singer",
    code = "code",
    song = "song",
    Singer = "Singer",
    Code = "Code",
    Song = "Song",
    price_unit = "price_unit",
    date_time = "date_time",
    channel_type = "channel_type",
    price = "price",
    duration = "duration",
    validity = "validity",
    transaction_type = "transaction_type",
    ACTIVATED = "ACTIVATED",
    DEACTIVATED = "DEACTIVATED",
    RENEWED = "RENEWED",
    how_to_play_selected_tunes_to_your_callers = "how_to_play_selected_tunes_to_your_callers",
    learn_more = "learn_more",
    info = "info",
    profile_tunes = "profile_tunes",
    number_cannot_be_same_as_the_logged_in_number = "number_cannot_be_same_as_the_logged_in_number",
    your_tune_is_live_now = "your_tune_is_live_now",
    your_order_is_successfully_completed = "your_order_is_successfully_completed",
    your_order_is_failed = "your_order_is_failed",
    confirm_name_to_set_as_name_tunes = "confirm_name_to_set_as_name_tunes",
    confirm_request = "confirm_request",
    find_your_name = "find_your_name",
    type_to_search = "type_to_search",
    invalid_searchKey = "invalid_searchKey",
    invalid_search_type = "invalid_search_type",
    no_groups_avaliable = "no_groups_avaliable",
    no_time_type_avaliable = "no_time_type_avaliable",
    invalid_time_type = "invalid_time_type",
    internal_server_error = "internal_server_error",
    valid_subscriber = "valid_subscriber",
    invalid_mpt_subscriber = "invalid_mpt_subscriber",
    subscriber_not_registered = "subscriber_not_registered",
    subscriber_already_registered = "subscriber_already_registered",
    password_blocked = "password_blocked",
    invalid_friend_number = "invalid_friend_number",
    number_must_be_unique = "number_must_be_unique",
    unsubscribe = "unsubscribe",
    my_wishlist = "my_wishlist",
    NONE = "NONE",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY",
    DAILY_TIME = "DAILY_TIME",
    WEEKLY_TIME = "WEEKLY_TIME",
    MONTHLY_TIME = "MONTHLY_TIME",
    YEARLY_TIME = "YEARLY_TIME",
    CUSTOM_TIME = "CUSTOM_TIME",
    invalid_file_type = "invalid_file_type",
    thousand = "thousand",
    million = "million",
    //Header
    faq = "faq",
    about = "about",
    price_unit_per_month = "price_unit_per_month",
    back_arrow = "back_arrow",

    //Toolbar
    tunes = "tunes",
    doityourself = "doityourself",
    signin = "signin",

    //Login
    logintouraccount = "logintouraccount",
    mobilenumber = "mobilenumber",
    countrycode = "countrycode",
    numberIncorrect = "numberIncorrect",
    password = "password",
    passwordIncorrect = "passwordIncorrect",
    rememberme = "rememberme",
    forgotpassword = "forgorpassword",
    login = "login",
    dontvetheaccount = "dontvetheaccount",
    signup = "signup",
    incorrectpasswordpolicy = "incorrectpasswordpolicy",
    numberMinLength = "numberMinLength",
    numberMaxLength = "numberMaxLength",
    passwordMinLength = "passwordMinLength",
    passwordMaxLength = "passwordMaxLength",
    invalidLength = "invalidLength",

    //create account
    create_account = "create_account",
    confirm_password = "confirm_password",
    select_categories = "select_categories",
    douhaveaccount = "douhaveaccount",
    haveanaccount = "haveanaccount",
    categories_error_msg = "categories_error_msg",

    //landingPage
    explore_more_tunes = "explore_more_tunes",
    //request otp
    submit = "submit",
    enterotp = "enterotp",
    requestotp = "requestotp",
    confirmotp = "confirmotp",
    otp_max_length = "otp_max_length",
    otp_verification = "otp_verification",

    //confirmation
    successfull = "successfull",
    account_created = "account_created",
    login_now = "login_now",
    change_password_message = "change_password_message",

    //forgot password
    forgot_password = "forgot_password",

    //otp
    incorrectotp = "incorrectotp",
    didntreceivecode = "didntreceivecode",
    resendotp = "resendotp",
    zain_sudan = "zain_sudan",
    otp_message = "otp_message",
    confirmedpasswordmismatch = "confirmedpasswordmismatch",

    //footer
    categories = "categories",
    sudanese = "sudanese",
    arabic = "arabic",
    burmese = "burmese",
    islamic = "islamic",
    others = "others",
    company = "company",
    contactus = "contactus",
    privacy_policy = "privacy_policy",
    terms_condition = "terms_condition",
    follow_us = "follow_us",
    facebook = "facebook",
    twitter = "twitter",
    youtube = "youtube",
    linkedin = "linkedin",
    download = "download",
    copyright = "copyright",

    //tonedetails
    buy_now = "buy_now",
    browse_by_category = "browse_by_category",

    //navigationpaths
    home = "home",
    tune = "tune",
    search_results = "search_results",

    //search
    tones = "tones",
    artist = "artist",
    search_results_for = "search_results_for",

    //tellafriend
    tellafriend = "tellafriend",
    entercontactnumber = "entercontactnumber",
    invalidcontactnumber = "invalidcontactnumber",

    //buytone
    buytone = "buytone",
    buy_playlist = "buy_playlist",
    get_your_loved_tune = "get_your_loved_tune",
    SDG_for_60_days = "SDG_for_60_days",
    Subscription_charges_of_2_SDG_for_30_days = "Subscription_charges_of_2_SDG_for_30_days",

    //giftafriend
    gift_a_friend = "gift_a_friend",
    gift = "gift",
    settings = "settings",
    view = "view",
    buy = "buy",

    //shareatune
    shareatone = "shareatone",
    share = "share",

    //myaccount
    userName = "userName",
    usernameerrormsg = "usernameerrormsg",
    saveChanges = "saveChanges",
    editprofile = "editprofile",
    profileupdationsuccess = "profileupdationsuccess",
    profileupdationfailure = "profileupdationfailure",
    unsubscribersuccess = "unsubscribersuccess",
    subscriber_msg = "subscriber_msg",
    in_progress = "in_progress",
    preferences = "preferences",
    myaccount = "myaccount",
    Active = "active",
    InActive = "inactive",
    myprofile = "myprofile",
    mytunes = "mytunes",

    //wishlist
    view_wishlist = "view_wishlist",
    wishlist = "wishlist",
    playlist = "playlist",
    no_wishlist_at_the_moment = "no_wishlist_at_the_moment",

    //transactionhistory
    history = "history",
    no_history_at_the_moment = "no_history_at_the_moment",

    //salati
    reminder_content = "reminder_content",
    //faq
    how_can_i_help_you = "how_can_i_help_you",

    //doityourself
    doityourself_msg = "doityourself_msg",
    tunename = "tunename",
    tune_name_max_length = "tune_name_max_length",
    choose_file = "choose_file",
    uploading = "uploading",
    uploaded = "uploaded",
    replace = "replace",
    drop_your_file_here = "drop_your_file_here",
    browse = "browse",
    support_mp3_file = "support_mp3_file",
    failed_tryagain = "failed_tryagain",
    tunenameerrormsg = "tunenameerrormsg",
    i_have_read_and_agree_to_th = "i_have_read_and_agree_to_the",
    terms_conditions = "terms_conditions",
    tuneNameMinLength = "tuneNameMinLength",
    tuneNameMaxLength = "tuneNameMaxLength",
    tuneNameInvalidLength = "tuneNameInvalidLength",
    fileInvalidLength = "fileInvalidLength",
    fileMinLength = "fileMinLength",
    fileMaxLength = "fileMaxLength",

    //salati
    already_subscribed = "already_subscribed",
    subscribe = "subscribe",

    //banner
    banner_list = "banner_list",

    //playlist
    playlist_header = "playlist_header",
    playlist_description = "playlist_description",
    browse_tunes = "browse_tunes",

    //preview
    preview_tone = "preview_tone",
    likes = "likes",

    //mytunes
    karaoke = "karaoke",
    mylibrary = "mylibrary",
    currently_playing_tunes_in_list = "currently_playing_tunes_in_list",
    from = "from",
    to = "to",
    status = "status",
    callers = "callers",
    time = "time",
    repeat = "repeat",
    click_delete_icon = "click_delete_icon",
    remove_the_tune_settings_you_no_longer_want_to_play_to_your_callers = "remove_the_tune_settings_you_no_longer_want_to_play_to_your_callers",
    add_the_new_settings_on_your_my_library_tunes = "add_the_new_settings_on_your_my_library_tunes",
    want_to_edit_your_playing_list = "want_to_edit_your_playing_list",


    //tunesettings
    select_group = "select_group",
    add_new_group = "add_new_group",
    all_callers = "all_callers",
    callers_group = "callers_group",
    special_caller = "special_caller",
    add_to_shuffle = "add_to_shuffle",
    username_max_length = "username_max_length",
    group_name_max_length = "group_name_max_length",
    name_tune_max_length = "name_tune_max_length",
    none = "none",
    monthly = "monthly",
    yearly = "yearly",
    full_day = "full_day",
    select_time = "select_time",
    select_date_time = "select_date_time",
    set_date_time = "set_date_time",
    custom = "custom",
    invalid_group = "invalid_group",
    default_start_time = "default_start_time",
    default_end_time = "default_end_time",
    hrs = "24_hrs",
    time_greater_than_or_equal = "time_greater_than_or_equal",
    difference_more_than_30 = "difference_more_than_30",
    difference_more_than_365 = "difference_more_than_365",
    sun = "sun",
    mon = "mon",
    tue = "tue",
    wed = "wed",
    thu = "thu",
    fri = "fri",
    sat = "sat",
    sunday = "sunday",
    monday = "monday",
    tuesday = "tuesday",
    wednesday = "wednesday",
    thursday = "thursday",
    friday = "friday",
    saturday = "saturday",
    advance_setting = "advance_setting",
    select_to_whom_you_want_to_play_it = "select_to_whom_you_want_to_play_it",
    choose_date_time = "choose_date_time",
    specialCallerSetting = "specialCallerSetting",
    groupCallerSetting = "groupCallerSetting",
    all = "all",
    allcaller = "allcaller",
    shuffle = "shuffle",
    live = "live",
    zero = "zero",
    st = "st",
    nd = "nd",
    rd = "rd",
    th = "th",
    day = "day",
    days = "days",
    t = "t",
    zero_time = "zero_time",
    time_24 = "time_24",
    tryagain = 'tryagain',

    //group
    caller_group = "caller_group",
    view_group = "view_group",
    edit_group = "edit_group",
    create_group = "create_group",
    member_name = "member_name",
    group_name = "group_name",
    back = "back",
    show_more = "show_more",
    show_less = "show_less",

    //blacklist
    add_number = "add_number",
    blacklist = "blacklist",

    //do it yourself
    please_accept_terms_and_condition = "please_accept_terms_and_condition",
    Invalid_file_length = "Invalid_file_length",
    Failed_to_upload_file = "Failed_to_upload_file",

    //categories
    more = "more",
    K = 'K',
    M = "M",


    //tones
    The_tune_will_be_deleted_and_all_related_settings_will_no_longer_be_available = "The_tune_will_be_deleted_and_all_related_settings_will_no_longer_be_available",
    unsubscribe_confirm_msg = "unsubscribe_confirm_msg",
    wish_list = "wish_list",
    tell_a_friend = "tell_a_friend",
    go_to_home = "go_to_home",
    _share = "_share",
    delete_trash = "delete_trash",
    new_releases = "new_releases",
    just_for_you = "just_for_you",
    best_of_the_month = "best_of_the_month",
    //group
    caller_group_deleted_successfully = "caller_group_deleted_successfully",
    are_you_sure_you_want_to_delete_the_group = "are_you_sure_you_want_to_delete_the_group",
    my_caller_group = "my_caller_group",
    create_and_manage_group_msg = "create_and_manage_group_msg",
    group_list = "group_list",

    //popup
    tune_charge = "tune_charge",
    absolute_validity = "absolute_validity",
    select_more_than_one_tune_to_shuffle_them = "select_more_than_one_tune_to_shuffle_them",
    to_play_a_tune_to_a_specific_callers_or_groups = "to_play_a_tune_to_a_specific_callers_or_groups",
    number_validation = "number_validation",
    nametune_price = "nametune_price",
    resend_otp = "resend_otp",
    requested_name = "requested_name",
    aed_per_month = "aed_per_month",
    authenticatemsg = "authenticatemsg",
    select_one_tune_to_play_it_for_the_full_day_to_all_your_callers = "select_one_tune_to_play_it_for_the_full_day_to_all_your_callers",
    zero_date = "zero_date",
    thank_you_for_your_request_you_will_be_charged_2k_for_activation = "thank_you_for_your_request_you_will_be_charged_2k_for_activation",
    //home
    greet_caller_with_your_name_tunes = "greet_caller_with_your_name_tunes",
    you_are_about_to_delete_the_tune_settings_your_callers_will_no_longer_hear_it = "you_are_about_to_delete_the_tune_settings_your_callers_will_no_longer_hear_it",

    choose_your_subscription_plan = "choose_your_subscription_plan",
    you_should_subscribe_a_plan_before_you_buy_gift = "you_should_subscribe_a_plan_before_you_buy_gift",
    what_is_subscription = "what_is_subscription",
    monthly_pack = "monthly_pack",
    monthly_charge = "monthly_charge",
    weekly_charge = "weekly_charge",
    monthly_plan = "monthly_plan",
    active_subscriber = "active_subscriber",
    contact_number = "contact_number",
    daily_charge = "daily_charge",
    vip_charge = "vip_charge",
    weekly_pack = "weekly_pack",
    daily_pack = "daily_pack",
    vip_pack = "vip_pack",
    explore_more_tunes_on_mpt = "explore_more_tunes_on_mpt",


    //pagination
    previous = "previous",
    next = "next",
    start_time = "start_time",
    end_time = "end_time",

    start_date = "start_date",
    end_date = "end_date",

    //name tune pop up
    buy_nametune = 'buy_nametune',
    upgrade_pack = 'upgrade_pack',
    request_now = 'request_now',
    proceed = "proceed",
    nametune = "nametune",

    //do it yourself
    name_your_tune = "name_your_tune",
    no_result = "no_result",
    no_result_msg = "no_result_msg",

    tell_a_friend_msg = "tell_a_friend_msg",
    tell_a_friend_add_number = "tell_a_friend_add_number",
    tellafriend_successmsg = "tellafriend_successmsg",
    tellafriend_failuremsg = "tellafriend_failuremsg",
    friend_number = "friend_number",
    verify = "verify",
    subscription = "subscription",
    msisdn_validation = "msisdn_validation",
    select_time_type = "select_time_type",
    msisdn_example = "msisdn_example",
    subscription_pack_price_details = "subscription_pack_price_details",
    hours = "hours",
    minutes = "minutes",
    Say_hello_to_your_callers = "Say_hello_to_your_callers",
    Give_the_right_welcome_to_your_callers_before_you_say_hello = "Give_the_right_welcome_to_your_callers_before_you_say_hello",
    Change_your_waiting_ring_for_your_favorites_music_personal = "Change_your_waiting_ring_for_your_favorites_music_personal",
    Call_waiting_time_made_amazing = "Call_waiting_time_made_amazing",
    They_will_love_to_call_you = "They_will_love_to_call_you",
    Even_if_you_dont_respond = "Even_if_you_dont_respond",
    That_special_someone_for_that_special_moment = "That_special_someone_for_that_special_moment",
    Advanced_Settings = "Advanced_Settings",
    make_a_wish = "make_a_wish",
    free_unlimited_pack_upgrade = "free_unlimited_pack_upgrade",
    upgradePack = "upgradePack",
    upgrade_free_tune_pack = "upgrade_free_tune_pack",

    CRBT_VIP_OFFER_CODE = "CRBT_VIP_OFFER_CODE",
    CRBT_MONTHLY_OFFER_CODE = "CRBT_MONTHLY_OFFER_CODE",
    CRBT_DAILY_OFFER_CODE = "CRBT_DAILY_OFFER_CODE",
    CRBT_WEEKLY_OFFER_CODE = "CRBT_WEEKLY_OFFER_CODE",
    mobilenumberhint = "mobilenumberhint",
    otphint = "otphint",
    verify_yourself = "verify_yourself",
    buffet_pack = "buffet_pack",
    charges = "charges",
    pack_of_10_tunes = "pack_of_10_tunes",
    flash_message = "flash_message",
    flash_message_content = "flash_message_content",
    default_flash_message = "default_flash_message",
    you_should_subscribe_a_plan_before_you_flash_message = "you_should_subscribe_a_plan_before_you_flash_message",
    monthly_flash_charge = "monthly_flash_charge",
    weekly_flash_charge = "weekly_flash_charge",
    daily_flash_charge = "daily_flash_charge",
    monthly_flash = "monthly_flash",
    weekly_flash = "weekly_flash",
    daily_flash = "daily_flash",


    confirmation = "confirmation",
    subscription_plan_confirmation = "subscription_plan_confirmation",
    create_flash_confirmation = "create_flash_confirmation",
    edit_flash_confirmation = "edit_flash_confirmation",
    my_subscription_plan = "my_subscription_plan",
    expiring_on = "expiring_on",
    flash_message_subscription_status_change_success = "flash_message_subscription_status_change_success",
    flash_message_unsubscribe_success = "flash_message_unsubscribe_success",
    current_flash_message = "current_flash_message",
    set_now = "set_now",
    pause = "pause",
    resume = "resume",
    edit_flash_message = "edit_flash_message",
    create_flash_message = "create_flash_message",
    flash_message_delete_success = "flash_message_delete_success",
    edit_your_flash = "edit_your_flash",
    create_your_flash = "create_your_flash",
    flash_message_limit = "flash_message_limit",
    dedicate_flash_message = "dedicate_flash_message",
    show_dedicate = "show_dedicate",
    enter_your_message = "enter_your_message",
    predefined_flash_message = "predefined_flash_message",

    flash_message_disclaimer_content = "flash_message_disclaimer_content",
    flash_message_disclaimer_name = "flash_message_disclaimer_name",

    set = "set",
    status_tune_confiemation = "status_tune_confiemation",
    empty_profile_tune = "empty_profile_tune",
    reward_point_button_label = "reward_point_button_label",
    reward_point_popup_header = "reward_point_popup_header",
    reward_point_content = "reward_point_content",
}   



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/strings.ts